import { useEffect } from 'react'
import { NextPage } from 'next'
import { useRouter } from 'next/router'

import { useCookies } from '@/libs/helpers/hooks/useCookies'
import { useConfiguration } from '@/providers/configuration/ConfigurationContext'
import { LoadScreen } from '@/tbui'

const SignInPage: NextPage = () => {
  const { userSession } = useConfiguration()
  const router = useRouter()
  const { getRedirectURLCookie, removeRedirectURLCookie } = useCookies()

  useEffect(() => {
    if (userSession.isInitialized) {
      const redirectURL = { url: '/', as: '/', ...getRedirectURLCookie() }
      removeRedirectURLCookie()
      router.push(redirectURL.url, redirectURL.as)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSession.isInitialized])

  return <LoadScreen />
}

export default SignInPage
